// Rich per-brand content for individual brand pages.
// Keyed by slug. `match` maps to the brand `name` returned by /api/brands.

export const BRAND_DETAILS = {
  whichschooladvisor: {
    match: "WhichSchoolAdvisor",
    instagram: [
      { region: "Global",    handle: "whichschooladvisor",     widgetUrl: "" },
      { region: "Singapore", handle: "whichschooladvisor.sg",  widgetUrl: "" },
      { region: "UK",        handle: "whichschooladvisor.uk",  widgetUrl: "" },
      { region: "KSA",       handle: "whichschooladvisor.ksa", widgetUrl: "" },
    ],
    hero_image: "/reports/wsa-hero.webp",
    stats: [
      { value: "2013", label: "Launched" },
      { value: "7", label: "International markets" },
      { value: "3", label: "Continents" },
      { value: "18,000+", label: "Enquiries mediated" },
      { value: "2M+", label: "Parents reached each year" },
      { value: "#1", label: "Most trusted parent resource" },
    ],
    body: [
      "WhichSchoolAdvisor.com is where the search for the right school begins. Launched in 2013, it was the Gulf's first genuinely independent, parent-first resource for choosing a school — and it remains the most respected parent-facing site in every market it serves: the UAE, Saudi Arabia, the United Kingdom, Singapore, Hong Kong, Thailand and Vietnam.",
      "Every school we cover receives an in-depth, independent review. We detail the strengths that make a school special, and we are honest about the areas prospective parents may consider weaknesses for their own child's needs. There is no sponsorship dressed up as journalism here; our analysis is objective, evidence-led and written for one audience only — parents.",
      "The goal of the site is singular: to get parents to the last mile of decision-making. Choosing a school is one of the most consequential decisions a family will ever make, and it should never rest on hearsay. We combine curriculum knowledge, fee transparency, inspection outcomes and real parental insight so families can weigh their options with genuine confidence.",
      "Since launch, WhichSchoolAdvisor.com has been asked to actively mediate requests for further information from schools by more than 18,000 parents — and many multiples of that number have jumped directly from the site to a school of interest through published contact details. That reach, and the trust behind it, is why leading schools and education brands choose to partner with us.",
      "More than a directory, WhichSchoolAdvisor.com is a companion for the entire journey: from the first shortlist to the final enrolment, and every question in between. It is independent guidance, at scale, for the families who need it most — wherever in the world they are searching.",
    ],
    ad_guidelines: {
      intro: "WhichSchoolAdvisor.com offers responsive display advertising. Creative is uploaded at high resolution and scaled responsively to the reader's screen, ensuring crisp delivery on every device.",
      tech: { maxFile: "10 MB", formats: "JPG · GIF · PNG", responsive: "Responsive — display size is typically 50% of the uploaded pixel dimensions once the minimum screen width is met." },
      placements: [
        { name: "Leaderboard", profile: "Elegant" },
        { name: "In Article 1", profile: "Elegant" },
        { name: "In Article 2", profile: "Elegant" },
        { name: "In Article 3", profile: "Elegant" },
        { name: "In Article 4", profile: "Elegant" },
        { name: "In Article 5", profile: "Elegant" },
        { name: "In Article 6", profile: "Elegant" },
      ],
      jumbo: [
        { size: "1", upload: "656 × 544", display: "328 × 272", minScreen: "360" },
        { size: "2", upload: "1184 × 720", display: "592 × 360", minScreen: "624" },
        { size: "3", upload: "1440 × 720", display: "720 × 360", minScreen: "752" },
        { size: "4", upload: "1920 × 720", display: "960 × 360", minScreen: "992" },
        { size: "5", upload: "2432 × 720", display: "1216 × 360", minScreen: "1248" },
      ],
      elegant: [
        { size: "1", upload: "656 × 544", display: "328 × 272", minScreen: "360" },
        { size: "2", upload: "1184 × 336", display: "592 × 168", minScreen: "624" },
        { size: "3", upload: "1440 × 336", display: "720 × 168", minScreen: "752" },
        { size: "4", upload: "1920 × 336", display: "960 × 168", minScreen: "992" },
        { size: "5", upload: "2432 × 336", display: "1216 × 168", minScreen: "1248" },
        { size: "6", upload: "656 × 250", display: "328 × 125", minScreen: "0" },
      ],
    },
  },

  schoolscompared: {
    match: "SchoolsCompared",
    instagram: [
      { region: "Global", handle: "schoolscompared", widgetUrl: "" },
    ],
    hero_image: "/reports/sc-hero.webp",
    stats: [
      { value: "2015/16", label: "Launched in the UAE" },
      { value: "#1", label: "World's largest intl market" },
      { value: "100%", label: "Independent reviewers" },
      { value: "1-to-1", label: "Side-by-side comparison" },
      { value: "Oscars", label: "Organiser of the Awards" },
      { value: "24/7", label: "News desk" },
    ],
    body: [
      "SchoolsCompared.com was created to give parents something no one else offered: the ability to compare schools directly, side by side. Staffed by its own independent team of reviewers, the site focuses on international schools in the United Arab Emirates — the largest international school market in the world.",
      "What sets SchoolsCompared.com apart is the marriage of two things that rarely sit together. First, genuinely in-depth reviews — long-form, forensic assessments written by specialists who visit, question and probe. Second, hard, comparable data: the fees, curricula, results, inspection ratings and facilities that define a school, presented so families can line up their options and see the differences at a glance.",
      "The result is clarity at the most important moment. Parents arrive with a longlist and leave with a shortlist they trust, because every judgement is independent and every statistic is verifiable. There is no pay-to-play; reviews are earned, never bought.",
      "SchoolsCompared.com is also the organiser of the Top Schools Awards — described by UAE media as the 'Oscars of education' and now the most prestigious and respected awards in the sector. Through the awards, the site celebrates the schools, leaders and teachers setting the standard, and reinforces the benchmarks that raise quality across the market.",
      "For schools and education brands, SchoolsCompared.com offers something uniquely valuable: an audience of high-intent parents at the precise moment of choosing. For parents, it offers something even rarer — the confidence that comes from comparing the things that actually matter, honestly and in one place. It is data-driven, fiercely independent and built, above all, to help families make the final, right decision for their child.",
    ],
    ad_guidelines: {
      intro: "SchoolsCompared.com offers responsive display advertising across its most valuable, high-intent placements. Creative is uploaded at high resolution and scaled responsively to the reader's screen, ensuring crisp delivery on every device.",
      flexible: "The Flexible Package allows advertisers booked into In Article 3, 4 and 5 the possibility of being upgraded to the premium In Article 1 position — subject to inventory availability.",
      tech: { maxFile: "10 MB", formats: "JPG · GIF · PNG", responsive: "Responsive — display size is typically 50% of the uploaded pixel dimensions once the minimum screen width is met." },
      placements: [
        { name: "Leaderboard", profile: "Elegant" },
        { name: "In Article 1", profile: "Elegant" },
        { name: "In Article 2", profile: "Elegant" },
        { name: "In Article 3", profile: "Elegant" },
        { name: "In Article 4", profile: "Elegant" },
        { name: "In Article 5", profile: "Elegant" },
      ],
      jumbo: [
        { size: "1", upload: "656 × 544", display: "328 × 272", minScreen: "360" },
        { size: "2", upload: "1184 × 720", display: "592 × 360", minScreen: "624" },
        { size: "3", upload: "1440 × 720", display: "720 × 360", minScreen: "752" },
        { size: "4", upload: "1920 × 720", display: "960 × 360", minScreen: "992" },
        { size: "5", upload: "2432 × 720", display: "1216 × 360", minScreen: "1248" },
      ],
      elegant: [
        { size: "1", upload: "656 × 544", display: "328 × 272", minScreen: "360" },
        { size: "2", upload: "1184 × 336", display: "592 × 168", minScreen: "624" },
        { size: "3", upload: "1440 × 336", display: "720 × 168", minScreen: "752" },
        { size: "4", upload: "1920 × 336", display: "960 × 168", minScreen: "992" },
        { size: "5", upload: "2432 × 336", display: "1216 × 168", minScreen: "1248" },
      ],
    },
  },

  "top-schools-awards": {
    match: "Top Schools Awards",
    hero_image: "/reports/tsa-hero.jpeg",
    hero_video: "https://player.vimeo.com/video/344482310?autoplay=1&loop=1&muted=1&title=0&byline=0&portrait=0&autopause=0",
    stats: [
      { value: "2016/17", label: "First held" },
      { value: "Oscars", label: "…of education (UAE media)" },
      { value: "#1", label: "Most prestigious in the UAE" },
      { value: "20+", label: "Award categories" },
      { value: "100s", label: "Schools entered" },
      { value: "1", label: "Landmark gala night" },
    ],
    body: [
      "The Top Schools Awards are the most prestigious and respected awards for the education sector in the United Arab Emirates — described by UAE media as the 'Oscars of the education world'. Launched in 2016/17 and organised by SchoolsCompared.com, they have become the benchmark by which excellence in the region's schools is recognised and celebrated.",
      "What makes the awards matter is the credibility behind them. They are the product of a year-round programme of independent reviews, data analysis and on-the-ground expertise. Winning is not a matter of marketing budget; it is earned through demonstrable excellence in teaching, leadership, inclusion, wellbeing, innovation and outcomes. That independence is why a Top Schools Award carries genuine weight with parents, educators and owners alike.",
      "Each year the awards recognise achievement across a wide range of categories — spanning academic performance, value, sport, the arts, special educational needs provision, early years, sustainability and the individuals who make the difference: teachers and school leaders. The result is a portrait of the very best of UAE education, and a powerful incentive for the whole sector to raise its game.",
      "For schools, recognition provides authentic, third-party validation that resonates with prospective families. For parents, the awards offer a trusted signpost to quality. And for the sector as a whole, they set and continually lift the standard.",
      "The Top Schools Awards culminate in a landmark ceremony that brings the education community together to honour its finest — a night that has become one of the most anticipated fixtures in the UAE education calendar, and a lasting mark of distinction for every school fortunate enough to be named among the best.",
    ],
  },

  edinformaplus: {
    match: "EdinformaPlus",
    hero_image: "/reports/edinforma-hero.webp",
    hero_animation: { origin: "63% 8%", scale: 1.45, duration: 10 },
    stats: [
      { value: "3", label: "Data sources combined" },
      { value: "Peer", label: "Benchmarking engine" },
      { value: "Live", label: "Continuously updated" },
      { value: "100%", label: "Proprietary data" },
      { value: "B2B", label: "Subscription service" },
      { value: "DD", label: "Due-diligence grade" },
    ],
    body: [
      "EdinformaPlus combines three distinct forms of data to deliver an unparalleled view of how individual schools perform within the international school sector — intelligence that simply cannot be found anywhere else.",
      "It is built for the business of education. Designed as a subscription service for the leaders who run schools, and the admissions and marketing teams that need to fill them, EdinformaPlus turns raw information into decisions. Where due diligence once relied on fragmented, out-of-date or anecdotal inputs, it provides a rigorous, continuously updated evidence base.",
      "Crucially, the platform brings that data to life. Rather than static spreadsheets, subscribers get tools that benchmark a specific school's performance against its true peers — by curriculum, price point, location and profile. Patterns that were once invisible become obvious: where a school leads, where it lags, and where the opportunity lies.",
      "The value compounds over time. EdinformaPlus is continually adding new datasets, and in doing so delivers ever-greater alpha, insight and competitive advantage to its subscribers. In a market where established schools are being forced to re-evaluate their operating frameworks as competition intensifies, that edge is decisive.",
      "For an owner planning growth, EdinformaPlus reveals how a portfolio stacks up and where to invest. For an investor weighing an acquisition, it de-risks the decision with hard evidence. For a lender, it provides the independent, defensible view that underpins responsible finance. This is the analytical backbone of the Which Media group — proprietary, benchmarked and built for people who make consequential decisions about schools.",
    ],
    access: {
      title: "How to access EdinformaPlus",
      intro: "EdinformaPlus is unlocked from within your EdInforma school account. Follow these four steps to subscribe.",
      steps: [
        { text: "Ensure that you own your school account on EdInforma. If you do not, you will need to apply for the school account here:", url: "https://edinforma.com/sign-up", urlLabel: "edinforma.com/sign-up" },
        { text: "When you have the account, sign into EdInforma. You will see your school or schools." },
        { text: "Navigate to the school for which you need the help of EdinformaPlus. You will find an EdinformaPlus subscribe button as an option below the school name, then subscribe." },
        { text: "EdinformaPlus will appear as a new menu in the left-hand column." },
      ],
    },
  },

  "education-intelligence-group": {
    match: "Education Intelligence Group",
    hero_image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?crop=entropy&cs=srgb&fm=jpg&q=80&w=1900&fit=crop",
    hero_images: [
      "/reports/eig-hero-1.png",
      "/reports/eig-hero-2.png",
      "/reports/eig-hero-3.png",
    ],
    stats: [
      { value: "$30m+", label: "Decisions informed" },
      { value: "Decades", label: "UAE experience" },
      { value: "100%", label: "Agenda-free analysis" },
      { value: "A–Z", label: "Curriculum expertise" },
      { value: "360°", label: "UAE market map" },
      { value: "1", label: "Peerless network" },
    ],
    body: [
      "The Education Intelligence Group (EIG) is the consultancy arm of Which Media — a team of passionate educationalists with decades of experience in the United Arab Emirates, driven by a single ambition: to help build a better education sector.",
      "We do that by sharing what we know. Whether you are modelling a new business, refining an operating framework or implementing change on the ground, the EIG brings data, insight, practical know-how and operational skill to the table — and a network of relationships built over many years.",
      "The stakes could not be higher. When investors are considering spending upwards of US$30 million to develop a school in the UAE, an unfettered, agenda-free analysis is vital. That analysis must be founded on fact — and through peerless contacts and proprietary research, the EIG provides a specific, up-to-the-minute, detailed map of the UAE school landscape.",
      "Our specialists have developed their market insight from the ground up. They have managed relationships with regulators, investors, real-estate and construction companies and school leaders, and their judgement is tried and tested. As the competitive landscape intensifies, even established schools are being forced to re-evaluate their strategies; commercial marketing and admissions have become critical to every school's plan, and the insight we bring ensures our clients stay ahead.",
      "We are curriculum experts, with deep experience of establishing a wide array of curricula and an understanding of the cost implications of each. We are UAE experts, with the local knowledge to get things done. And we are communications experts — meaning we can not only help build your business case, but help you make it persuasively. Independent, expert and relentlessly practical: that is the EIG.",
    ],
    reports: [
      {
        title: "Education Intelligence — Issue 1",
        blurb: "The inaugural edition of our flagship intelligence briefing on the UAE education landscape.",
        cover: "/reports/cover-eig-education-intelligence-issue-1.png",
        file: "/reports/eig-education-intelligence-issue-1.pdf",
      },
      {
        title: "Education Intelligence — Issue 2",
        blurb: "The second edition — the latest data, analysis and market movements across the sector.",
        cover: "/reports/cover-eig-education-intelligence-issue-2.png",
        file: "/reports/eig-education-intelligence-issue-2.pdf",
      },
      {
        title: "The Professional Learning Report",
        blurb: "An in-depth look at professional learning and development across UAE schools.",
        cover: "/reports/cover-eig-professional-learning-report.png",
        file: "/reports/eig-professional-learning-report.pdf",
      },
      {
        title: "The Mystery Shoppers Report",
        blurb: "What really happens when parents enquire — a candid, data-led study of the admissions experience.",
        cover: "/reports/cover-eig-mystery-shoppers-report.png",
        file: "/reports/eig-mystery-shoppers-report.pdf",
      },
    ],
  },

  whichuniversityadvisor: {
    match: "WhichUniversityAdvisor",
    hero_image: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1900",
    stats: [
      { value: "Soon", label: "Launching" },
      { value: "Global", label: "Coverage" },
      { value: "Higher Ed", label: "Our new focus" },
      { value: "100%", label: "Independent" },
      { value: "1", label: "Natural next step" },
      { value: "0", label: "Agenda" },
    ],
    body: [
      "WhichUniversityAdvisor.com is the next chapter for Which Media — and it brings the same independence, rigour and parent-first spirit that defined WhichSchoolAdvisor.com to the world of higher education.",
      "Choosing a university is the natural sequel to choosing a school, and it is every bit as consequential. Yet families navigating applications, courses, campuses and countries face a bewildering volume of marketing and a shortage of genuinely independent guidance. WhichUniversityAdvisor.com will change that.",
      "Built on the foundations of a decade of trusted education journalism, the site will offer honest analysis of institutions worldwide, clear comparison of the factors that matter — outcomes, value, student experience and graduate destinations — and practical support for the entire decision journey, from first shortlist to final acceptance.",
      "For the students and families who have grown up trusting WhichSchoolAdvisor.com, it is a familiar promise extended to a new stage of life: no agenda, no hype, just the truth needed to make one of life's biggest decisions with confidence.",
      "WhichUniversityAdvisor.com is coming soon. Register your interest with our team and be among the first to know the moment it launches.",
    ],
  },
};

export const brandSlugByName = Object.fromEntries(
  Object.entries(BRAND_DETAILS).map(([slug, d]) => [d.match, slug])
);

/**
 * Merge the DB `brand` doc with the hardcoded BRAND_DETAILS fallback for a slug.
 * DB values win when they are non-empty; otherwise the frontend config is used.
 * This lets admins edit any field via the CMS without breaking pages when a
 * field hasn't been set yet.
 */
const nonEmpty = (v) => {
  if (v == null) return false;
  if (typeof v === "string") return v.trim() !== "";
  if (Array.isArray(v)) return v.length > 0;
  if (typeof v === "object") return Object.keys(v).length > 0;
  return true;
};

export const resolveBrandDetail = (brand = {}, detail = {}) => {
  const keys = [
    "hero_image", "hero_images", "hero_animation", "hero_video",
    "stats", "body", "access", "ad_guidelines", "reports", "instagram",
  ];
  const merged = { ...detail };
  for (const k of keys) {
    if (nonEmpty(brand[k])) merged[k] = brand[k];
  }
  return merged;
};
